import React, { type ComponentType } from 'react';
import noop from 'lodash/noop';
import Button from '@atlaskit/button';
import { ModalBody, ModalFooter, ModalHeader, ModalTitle } from '@atlaskit/modal-dialog';
import { JiraModal as ModalDialog } from '@atlassian/jira-modal/src/ui/jira-modal.tsx';
import ShortcutScope from '@atlassian/jira-common-components-keyboard-shortcuts/src/shortcut-scope.tsx';
import { injectIntlV2 as injectIntl } from '@atlassian/jira-intl/src/v2/inject.tsx';
import type { IntlShapeV2 as IntlShape } from '@atlassian/jira-intl/src/v2/types.tsx';
import { getWillShowNav4 } from '@atlassian/jira-navigation-apps-sidebar-nav4-rollout-core/src/common/utils/get-will-show-nav4/index.tsx';
import messages from './messages.tsx';

type Props = {
	Content: ComponentType<{
		onAddLink: () => void;
		onAddRepo: () => void;
	}>;
	onClose: () => void;
	onAddLink: () => void;
	onAddRepo: () => void;
	intl: IntlShape;
};

function SelectItemTypeModal(props: Props) {
	const { Content, onClose, onAddLink, onAddRepo } = props;
	const {
		intl: { formatMessage },
	} = props;
	const qualityProps = {
		width: 'medium',
	};
	const cancelText = messages.cancel;

	return (
		<ShortcutScope>
			<ModalDialog
				messageId="navigation-shortcuts.main.add-item.select-item-type-modal.modal-dialog"
				messageType="transactional"
				onClose={onClose}
				{...qualityProps}
				autoFocus={false}
				shouldCloseOnOverlayClick={false}
			>
				<ModalHeader>
					<ModalTitle>
						{getWillShowNav4()
							? formatMessage(messages.headerShortcuts)
							: formatMessage(messages.header)}
					</ModalTitle>
				</ModalHeader>
				<ModalBody>
					<Content onAddLink={onAddLink} onAddRepo={onAddRepo} />
				</ModalBody>
				<ModalFooter>
					<Button appearance="link" onClick={onClose}>
						{formatMessage(cancelText)}
					</Button>
				</ModalFooter>
			</ModalDialog>
		</ShortcutScope>
	);
}

SelectItemTypeModal.defaultProps = {
	onClose: noop,
};

export default injectIntl(SelectItemTypeModal);
